import {Inject, Injectable} from '@angular/core';
import {
    MX_PERMISSION_TOKEN,
    MxPermissionService,
    PermissionActions, RESTRICTED
} from '../../../shared/services/mx-permission.service';
import {MxGridButtonsConfig} from './mx-grid-button.model';
import {DefaultGridButtons} from './mx-grid-enums';



@Injectable({
    providedIn: 'root'
})
export class MxDefaultGridButtonsPermissionsService {

    constructor(@Inject(MX_PERMISSION_TOKEN) private permissionService: MxPermissionService) {
    }

    public setGridButtonPermission(permission: string, buttonsConfig: MxGridButtonsConfig): void {
        if (!permission) {
            return;
        }
        let permissionWithoutAction = this.permissionService.getPermissionWithoutAction(permission);
        let buttonsPermissions: PermissionActions;
        if (this.permissionService.hasRole(permissionWithoutAction)) {
            buttonsPermissions = {
                view: permissionWithoutAction,
                edit: permissionWithoutAction,
                add: permissionWithoutAction,
                delete: permissionWithoutAction
            };
        } else {
            buttonsPermissions = this.permissionService.getPermissionActions(permissionWithoutAction);
        }
        if (!buttonsPermissions) {
            return;
        }

        if (buttonsPermissions.add) {
            buttonsConfig.get(DefaultGridButtons.add).permission = buttonsPermissions.add;
            buttonsConfig.get(DefaultGridButtons.paste).permission = buttonsPermissions.add;
        } else {
            buttonsConfig.get(DefaultGridButtons.add).permission = RESTRICTED;
            buttonsConfig.get(DefaultGridButtons.paste).permission = RESTRICTED;
        }
        if (buttonsPermissions.delete) {
            buttonsConfig.get(DefaultGridButtons.remove).permission = buttonsPermissions.delete;
        } else {
            buttonsConfig.get(DefaultGridButtons.remove).permission = RESTRICTED;
        }
        if (buttonsPermissions.edit) {
            buttonsConfig.get(DefaultGridButtons.edit).permission = buttonsPermissions.edit;
            buttonsConfig.get(DefaultGridButtons.moveUp).permission = buttonsPermissions.edit;
            buttonsConfig.get(DefaultGridButtons.moveDown).permission = buttonsPermissions.edit;
        } else {
            buttonsConfig.get(DefaultGridButtons.edit).permission = RESTRICTED;
            buttonsConfig.get(DefaultGridButtons.moveUp).permission = RESTRICTED;
            buttonsConfig.get(DefaultGridButtons.moveDown).permission = RESTRICTED;
        }
        if (buttonsPermissions.view) {
            buttonsConfig.get(DefaultGridButtons.view).permission = buttonsPermissions.view;
        } else {
            buttonsConfig.get(DefaultGridButtons.view).permission = RESTRICTED;
        }
        if (buttonsPermissions.view && buttonsPermissions.view.startsWith('role') ||
            buttonsPermissions.add && buttonsPermissions.add.startsWith('role') ||
            buttonsPermissions.edit && buttonsPermissions.edit.startsWith('role')
        ) {
            buttonsConfig.get(DefaultGridButtons.copy).permission = buttonsPermissions.view;
        } else if (buttonsPermissions.view || buttonsPermissions.add || buttonsPermissions.edit) {
            let copyPermission = '';
            if (buttonsPermissions.add) {
                copyPermission += buttonsPermissions.add;
            }
            if (buttonsPermissions.edit) {
                if (copyPermission.length > 0) {
                    copyPermission = `(${copyPermission} || ${buttonsPermissions.edit})`;
                } else {
                    copyPermission += buttonsPermissions.edit;
                }
            }
            if (buttonsPermissions.view) {
                if (copyPermission.length > 0) {
                    copyPermission = `${buttonsPermissions.view} && ${copyPermission}`;
                } else {
                    copyPermission += buttonsPermissions.view;
                }
            }
            buttonsConfig.get(DefaultGridButtons.copy).permission = copyPermission;
        } else {
            buttonsConfig.get(DefaultGridButtons.copy).permission = RESTRICTED;
        }
    }
}
